<div class="nav-container">
  <nav id="main-menu-navigation" class="navigation-main">
    <!-- خدمة التشخيص -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/online.png" class="img-fluid" alt="SEU"> -->
        <img
          src="assets/images/icons/smart-phone-icon.svg"
          class="img-fluid"
          alt="smart phone icon"
          style="width: 24px"
        />
        <span>خدمة التشخيص</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/auth/basic-data/Platform']"
        >
          <!-- <img src="assets/images/ava.png" class="img-fluid"
            alt="SEU"> -->
          <img
            src="assets/images/icons/laptop-icon.svg"
            class="img-fluid"
            alt="laptop icon"
            style="width: 24px"
          />
          <span>التعريف بالخدمة</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/P-Diagnosis']"
        >
          <!-- <img src="assets/images/add.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/payment-icon.svg"
            class="img-fluid"
            alt="payment icon"
            style="width: 24px"
          />
          <span>الدفع</span
          ><span *ngIf="diagnosisIsPaid" class="Done px-4"> تم </span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/auth/basic-data/case-history']"
        >
          <!-- <img
            src="assets/images/medicall.png"
            class="img-fluid"
            alt="SEU"
          /> -->

          <img
            src="assets/images/icons/medical-report-dark.svg"
            class="img-fluid"
            alt="report icon"
            style="width: 24px"
          />
          <span>التاريخ المرضي</span>
          <span *ngIf="IsCaseHisoryTaken" class="Done px-4"> تم </span>
        </a>

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/ExamOases']"
        >
          <!-- <img
            src="assets/images/question.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/user-question-icon1.svg"
            class="img-fluid"
            alt="user question icon"
            style="width: 24px"
          />
          <span>اختبار Oases</span
          ><span *ngIf="IsOasesTaken" class="Done px-4"> تم </span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/ExamSSRS']"
        >
          <!-- <img
            src="assets/images/question2.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/user-question-icon2.svg"
            class="img-fluid"
            alt="user question icon"
            style="width: 24px"
          />
          <span>اختبار SSRS</span
          ><span *ngIf="IsSSRSTaken" class="Done px-4"> تم </span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/AssigmeSSI-4']"
        >
          <!-- <img
            src="assets/images/manual.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/list-icon.svg"
            class="img-fluid"
            alt="list icon"
            style="width: 24px"
          />
          <span>اختبار <span lang="en">SSI-4</span> </span
          ><span *ngIf="IsSSI4Taken" class="Done px-4"> تم </span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/auth/basic-data/Booking']"
        >
          <!-- <img
            src="assets/images/calendar.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/calendar-icon.svg"
            class="img-fluid"
            alt="calendar icon"
            style="width: 24px"
          />
          <span>حجز موعد مع المختص</span
          ><span *ngIf="IsBookingTaken" class="Done mr-1 px-1"> تم </span></a
        >
      </div>
    </div>

    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/PatientBooking']"
      >
        <!-- <img src="assets/images/cal2.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/calendar-icon2.svg"
          class="img-fluid"
          alt="calendar icon"
          style="width: 24px"
        />
        <span> جدول الحجوزات</span></a
      >
    </div>

    <!-- خدمة العلاج -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/medicinee.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/medicine-icon-dark.svg"
          class="img-fluid"
          alt="medicine icon"
          style="width: 24px"
        />
        <span>خدمة العلاج</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/TreatmentPlatform']"
        >
          <!-- <img src="assets/images/ava.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/laptop-icon.svg"
            class="img-fluid"
            alt="laptop icon"
            style="width: 24px"
          />

          <span>التعريف بالخدمة</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/P-Treatment']"
        >
          <!-- <img src="assets/images/add.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/payment-icon.svg"
            class="img-fluid"
            alt="payment icon"
            style="width: 24px"
          />
          <span>الدفع</span
          ><span *ngIf="treatmentIsPaid" class="Done px-4"> تم </span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/PreTreatment']"
        >
          <!-- <img
            src="assets/images/course.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/book-open.svg"
            class="img-fluid"
            alt="book icon"
            style="width: 24px"
          />
          <span>استبيان ما قبل العلاج</span
          ><span *ngIf="IsPreTreatmentTaken" class="Done mr-2 px-1">
            تم
          </span></a
        >

        <!-- المرحلة العلاجية الأولى -->
        <div class="nav-item has-sub" routerLinkActive="active">
          <a href="javascript:void(0)" class="pl-35 sub-sub">
            <!-- <img
              src="assets/images/health-check.png"
              class="img-fluid"
              alt="SEU"
            /> -->
            <img
              src="assets/images/icons/heart1.svg"
              class="img-fluid"
              alt="heart icon"
              style="width: 24px"
            />
            <span> المرحلة العلاجية الأولى </span>
          </a>

          <div class="submenu-content">
            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/TreatmentStageOneSessions']"
            >
              <!-- <img
                src="assets/images/health-check.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/heart1.svg"
                class="img-fluid"
                alt="heart icon"
                style="width: 24px"
              />
              <span> الجلسات العلاجية </span
              ><span *ngIf="IsTreatmentS1Taken" class="Done mr-1 px-1">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/ExamOases/TREAT_FIRST_STAGE']"
            >
              <!-- <img
                src="assets/images/question.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/user-question-icon1.svg"
                class="img-fluid"
                alt="user question icon"
                style="width: 24px"
              />
              <span>اختبار Oases</span
              ><span *ngIf="IsOasesTreStage1Taken" class="Done px-4">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/ExamSSRS/TREAT_FIRST_STAGE']"
            >
              <!-- <img
                src="assets/images/question2.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/user-question-icon2.svg"
                class="img-fluid"
                alt="user question icon"
                style="width: 24px"
              />
              <span>اختبار SSRS</span
              ><span *ngIf="IsSSRSTreStage1Taken" class="Done px-4">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/AssigmeSSI-4/TREAT_FIRST_STAGE']"
            >
              <!-- <img
                src="assets/images/manual.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/list-icon.svg"
                class="img-fluid"
                alt="list icon"
                style="width: 24px"
              />
              <span>اختبار <span lang="en">SSI-4</span> </span
              ><span *ngIf="IsSSI4TreStage1Taken" class="Done px-4">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/auth/basic-data/Booking/TREAT_FIRST_STAGE']"
            >
              <!-- <img
                src="assets/images/calendar.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/calendar-icon.svg"
                class="img-fluid"
                alt="calendar icon"
                style="width: 24px"
              />
              <span>حجز موعد مع المختص</span
              ><span *ngIf="IsBookingTreStage1Taken" class="Done mr-1 px-1">
                تم
              </span></a
            >
          </div>
        </div>

        <!-- المرحلة العلاجية الثانية -->
        <div class="nav-item has-sub" routerLinkActive="active">
          <a href="javascript:void(0)" class="pl-35 sub-sub">
            <!-- <img
              src="assets/images/healthcare.png"
              class="img-fluid"
              alt="SEU"
            /> -->
            <img
              src="assets/images/icons/heart2.svg"
              class="img-fluid"
              alt="heart icon"
              style="width: 24px"
            />
            <span> المرحلة العلاجية الثانية </span>
          </a>

          <div class="submenu-content">
            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/TreatmentStageTwoSessions']"
            >
              <!-- <img
                src="assets/images/health-check.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/heart1.svg"
                class="img-fluid"
                alt="heart icon"
                style="width: 24px"
              />
              <span> الجلسات العلاجية </span
              ><span *ngIf="IsTreatmentS2Taken" class="Done mr-1 px-1">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/ExamOases/TREATMENT_SECOND_STAGE']"
            >
              <!-- <img
                src="assets/images/question.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/user-question-icon1.svg"
                class="img-fluid"
                alt="user question icon"
                style="width: 24px"
              />
              <span>اختبار Oases</span
              ><span *ngIf="IsOasesTreStage2Taken" class="Done px-4">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/ExamSSRS/TREATMENT_SECOND_STAGE']"
            >
              <!-- <img
                src="assets/images/question2.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/user-question-icon2.svg"
                class="img-fluid"
                alt="user question icon"
                style="width: 24px"
              />
              <span>اختبار SSRS</span
              ><span *ngIf="IsSSRSTreStage2Taken" class="Done px-4">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/Sas/AssigmeSSI-4/TREATMENT_SECOND_STAGE']"
            >
              <!-- <img
                src="assets/images/manual.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/list-icon.svg"
                class="img-fluid"
                alt="list icon"
                style="width: 24px"
              />
              <span>اختبار <span lang="en">SSI-4</span> </span
              ><span *ngIf="IsSSI4TreStage2Taken" class="Done px-4">
                تم
              </span></a
            >

            <a
              class="menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/auth/basic-data/Booking/TREATMENT_SECOND_STAGE']"
            >
              <!-- <img
                src="assets/images/calendar.png"
                class="img-fluid"
                alt="SEU"
              /> -->
              <img
                src="assets/images/icons/calendar-icon.svg"
                class="img-fluid"
                alt="calendar icon"
                style="width: 24px"
              />
              <span>حجز موعد مع المختص</span
              ><span *ngIf="IsBookingTreStage2Taken" class="Done mr-1 px-1">
                تم
              </span></a
            >
          </div>
        </div>

        <!-- التشخيص العلاجى النهائى -->
        <!-- <div class="nav-item has-sub " routerLinkActive="active">
          <a href="javascript:void(0)" class="pl-35 sub-sub"> <img src="assets/images/prog.png" class="img-fluid" alt="SEU">
            <span> التشخيص العلاجى النهائى </span>
          </a>

          <div class="submenu-content">

            <a class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              [routerLink]="['/Sas/ExamOases/DIAGONSES_LAST']"> <img src="assets/images/question.png" class="img-fluid"
                alt="SEU"><span>اختبار Oases</span><span *ngIf="IsOasesLastTaken" class="Done px-4"> تم </span></a>

            <a class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              [routerLink]="['/Sas/ExamSSRS/DIAGONSES_LAST']"> <img src="assets/images/question2.png" class="img-fluid"
                alt="SEU"><span>اختبار SSRS</span><span *ngIf="IsSSRSLastTaken" class="Done px-4"> تم </span></a>

            <a class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              [routerLink]="['/Sas/AssigmeSSI-4/DIAGONSES_LAST']"> <img src="assets/images/manual.png" class="img-fluid"
                alt="SEU"><span>اختبار SSI-4</span><span *ngIf="IsSSI4LastTaken" class="Done px-4"> تم </span></a>

            <a class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              [routerLink]="['/auth/basic-data/Booking/DIAGONSES_LAST']"> <img src="assets/images/calendar.png" class="img-fluid"
                alt="SEU"><span>حجز موعد مع المختص</span><span *ngIf="IsBookingLastTaken" class="Done mr-1 px-1"> تم </span></a>
          </div>
        </div> -->
      </div>
    </div>

    <div class="nav-item">
      <a
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/TreatmentSessionResult']"
      >
        <!-- <img
          src="assets/images/college.png"
          class="img-fluid"
          alt="SEU"
        /> -->
        <img
          src="assets/images/icons/hospital-icon-dark.svg"
          class="img-fluid"
          alt="hospital icon"
          style="width: 24px"
        />
        <span> الجلسات العلاجية السابقة</span></a
      >
    </div>

    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/PatientReports']"
      >
        <!-- <img
          src="assets/images/medical-file.png"
          class="img-fluid"
          alt="SEU"
        /> -->
        <img
          src="assets/images/icons/list-icon.svg"
          alt="list icon"
          class="img-fluid"
          style="width: 24px"
        />
        <span>التقارير الطبية</span></a
      >
    </div>

    <!-- خدمة مستشارك في التخاطب -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/contacts.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/calling-icon.svg"
          class="img-fluid"
          alt="calling icon"
          style="width: 24px"
        />
        <span>خدمة مستشارك في التخاطب</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/ConsultantPlatform']"
        >
          <!-- <img src="assets/images/ava.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/laptop-icon.svg"
            class="img-fluid"
            alt="laptop icon"
            style="width: 24px"
          />
          <span>التعريف بالخدمة</span></a
        >
        <!--
            <a class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            [routerLink]="['/Sas/PaymentConsultant']"> <img src="assets/images/add.png" class="img-fluid"
            alt="SEU"><span>الدفع</span></a> -->

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/BookingConsultation']"
        >
          <!-- <img
            src="assets/images/calendar.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/calendar-icon.svg"
            class="img-fluid"
            alt="calendar icon"
            style="width: 24px"
          />
          <span> حجز موعد للاستشارة</span></a
        >
      </div>
    </div>

    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/Sas/Patient-profile']"
      >
        <!-- <img src="assets/images/ava.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/laptop-icon.svg"
          class="img-fluid"
          alt="laptop icon"
          style="width: 24px"
        />
        <span>الملف الشخصي</span></a
      >
    </div>
  </nav>
</div>
